module.exports = __webpack_public_path__ + "img/slide_002_g3.6fe4959f.jpg";